
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import StatesContent from "./components/StatesContent.vue";


export default defineComponent({
  name: "JourneysPage",
  components: {
    BreadCrumb,
    StatesContent
},
});
